import React from 'react';

class FileUpload extends React.Component {
  handleFileClick() {
    if (this.props.fileAttached) {
      // File already attached
      return;
    }
    this.refs.fileInputRef.click();
  }

  render() {
    let icon = (
      <div className="icon-holder green circle">
        <img src="https://cdn-assets.alltrails.com/assets/icons/plusIcon.png" />
      </div>
    );
    let body = (
      <div className="text-group">
        <span className="prompt">{this.props.strings.dragSupportedFiles}</span>
        <span className="body3">
          <a>{this.props.strings.orChooseFile}</a>
        </span>
      </div>
    );

    if (this.props.fileAttached) {
      icon = (
        <div className="icon-holder">
          <img src="https://cdn-assets.alltrails.com/assets/icons/file-upload-check.png" />
        </div>
      );
      body = (
        <div className="text-group">
          <div className="prompt break-word">{this.props.fileName}</div>
          {this.props.progress}
          <div className="caption2">
            {this.props.strings.fileSizeText}: {this.props.fileSize}
          </div>
          <div className="remove" onClick={this.props.handleRemove}>
            {this.props.strings.removeFileText}
          </div>
        </div>
      );
    }
    return (
      <div className={`file-upload-wrapper ${!this.props.fileAttached ? 'clickable' : 'attached'}`} onClick={this.handleFileClick.bind(this)}>
        <div className="content-group">
          <div className="upload-icon">
            <div className="icon-holder">
              <div className="icon">{icon}</div>
            </div>
          </div>
          <input type="file" key={this.props.key} className="hidden" id="file" ref="fileInputRef" onChange={this.props.handleChange} />
          {body}
        </div>
      </div>
    );
  }
}

export { FileUpload };
